import { Player } from "@remotion/player";
import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EnglishAdvertisement } from "../components/composition/english-advertisement/EnglishAdvertisement";

function getDateItem(data) {
  if (data && data.length === 8) {
    return (
      <option key={data} value={data}>
        {data.substring(0, 4)}-{data.substring(4, 6)}-{data.substring(6)}
      </option>
    );
  } else {
    return (
      <option key={data} value={data}>
        {data}
      </option>
    );
  }
}

function getViewsItem(index, ccy1, ccy2, cnview) {
  return (
    <option key={index} value={index}>
      {ccy1} / {ccy2} ({cnview})
    </option>
  );
}

const splitCn = (text) => {
  if (!text) return ["", ""];
  const parts = text.split("。");
  const p1 = parts[0] ? parts[0] + "。" : "";
  const p2 = parts.slice(1).join("。");
  return [p1, p2];
};

const splitEn = (text) => {
  if (!text) return ["", ""];
  const parts = text.split(". ");
  const p1 = parts[0] ? parts[0] + (parts[0].endsWith(".") ? "" : ".") : "";
  const p2 = parts.length > 1 ? parts.slice(1).join(". ") : "";
  return [p1, p2];
};

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3030"
).replace(/\/$/, "");
const VIDEO_URL = (
  process.env.REACT_APP_VIDEO_URL || "http://localhost:3050"
).replace(/\/$/, "");

const Video = () => {
  const [sex, setSex] = useState("Male");
  const [lang, setLang] = useState("zn-CN");
  const [input_date, setInputDate] = useState("");
  const [input_json, setInputJSON] = useState([]);
  const [input_view, setView] = useState(0);
  const [input_active, setInputActive] = useState(true);
  const [input_datelist, setDateList] = useState([]);
  const [videoname, setVideoName] = useState("");
  const [loadingstatus, setLoadingStatus] = useState(false);
  const [temptype, setTempType] = useState("");
  const [tempselectedoption, setTempSelectedOption] = useState("");
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [audioVersion, setAudioVersion] = useState(Date.now());
  const [videoLoading, setVideoLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [s3DownloadInfo, setS3DownloadInfo] = useState(null);
  const [videoLink, setVideoLink] = useState("");
  const [activeRenders, setActiveRenders] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("scb_active_renders") || "{}");
    } catch (_) {
      return {};
    }
  });

  const updateActiveRender = (statusKey, data) => {
    setActiveRenders((prev) => {
      let updated;
      if (data === null) {
        updated = { ...prev };
        delete updated[statusKey];
      } else {
        updated = {
          ...prev,
          [statusKey]: { ...(prev[statusKey] || {}), ...data },
        };
      }
      try {
        sessionStorage.setItem("scb_active_renders", JSON.stringify(updated));
      } catch (_) {}
      return updated;
    });
  };

  const getBlueBtnStyle = (isDisabled) => ({
    backgroundColor: "#0d6efd",
    borderColor: "#0d6efd",
    color: "#ffffff",
    opacity: isDisabled ? 0.65 : 1,
    cursor: isDisabled ? "not-allowed" : "pointer",
  });

  const [previewProps, setPreviewProps] = useState({
    title: "SCB Daily Navigator",
    subtitle: "High Conviction Idea",
    color: "#0c55a9",
  });

  const [videoProps, setVideoProps] = useState({
    title: "SCB Daily Navigator",
    subtitle: "High Conviction Idea",
    color: "#0c55a9",
    lang: "zn-CN",
    date: "20260422",
    bullishNumber: 1.301,
    turnNeutral: 1.375,
    targetLevel: 1.354,
    entry: "",
    neutral: "",
    expect: "",
    ccy1: "",
    ccy2: "",
    cnview: "",
    msg1_1: "",
    msg1_2: "",
    msg2: "",
    audioList: [],
  });

  const maxCNLength = 100;
  const maxENLength = 300;

  const intervalRef = useRef(null);
  const videoLoadingTimeoutRef = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      entry: "",
      neutral: "",
      expect: "",
      ccy1: "",
      ccy2: "",
      cnview: "",
      voice: "Male",
      amended_msg1_1: "",
      amended_msg1_2: "",
      amended_msg2: "",
      eng_ccy1: "",
      eng_ccy2: "",
      eng_cnview: "",
      eng_voice: "Male",
      amended_eng_msg1_1: "",
      amended_eng_msg1_2: "",
      amended_eng_msg2: "",
      tw_ccy1: "",
      tw_ccy2: "",
      tw_cnview: "",
      tw_voice: "Male",
      amended_tw_msg1_1: "",
      amended_tw_msg1_2: "",
      amended_tw_msg2: "",
      tc_ccy1: "",
      tc_ccy2: "",
      tc_cnview: "",
      tc_voice: "Male",
      amended_tc_msg1_1: "",
      amended_tc_msg1_2: "",
      amended_tc_msg2: "",
    },
  });

  const watchAllFields = watch();

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (videoLoadingTimeoutRef.current)
        clearTimeout(videoLoadingTimeoutRef.current);
    };
  }, []);

  const triggerVideoLoading = () => {
    setVideoLoading(true);
    if (videoLoadingTimeoutRef.current) {
      clearTimeout(videoLoadingTimeoutRef.current);
    }
    videoLoadingTimeoutRef.current = setTimeout(() => {
      setVideoLoading(false);
    }, 1000);
  };

  useEffect(() => {
    fetch(API_BASE_URL + "/api/listdate?token=" + localStorage.getItem("token"))
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          localStorage.setItem("token", result.token);
          setDateList(result.data);
          if (result.data && result.data.length > 0) {
            HandleDateSelector(result.data[0]);
          }
        } else {
          window.location.href = "/";
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    // Resume tracking for any active renders from sessionStorage (e.g. after refresh)
    try {
      const storedRenders = JSON.parse(
        sessionStorage.getItem("scb_active_renders") || "{}",
      );
      Object.entries(storedRenders).forEach(([statusKey, info]) => {
        if (info && info.renderId) {
          const elapsed = Date.now() - (info.startTime || 0);
          if (elapsed < 360000) {
            // Less than 6 minutes old: resume polling
            pollVideoRenderStatus(
              statusKey,
              info.dateVal || "20260101",
              info.filename || "video.mp4",
              null,
              info,
              info.sex || "Male",
            );
          } else {
            updateActiveRender(statusKey, null);
          }
        }
      });
    } catch (_) {}
  }, []);

  const updateVideoUrlAndPreview = (
    dateStr,
    viewIdx,
    currentLang,
    viewData,
    formVals,
    version,
    overrideSex,
  ) => {
    triggerVideoLoading();
    const activeSex = overrideSex || sex || "Male";
    const sexSuffix = activeSex.toLowerCase();

    let vName = "";
    if (currentLang === "en")
      vName =
        VIDEO_URL + "/" + dateStr + viewIdx + "_en_" + sexSuffix + "_video.mp4";
    else if (currentLang === "yue-CN")
      vName =
        VIDEO_URL + "/" + dateStr + viewIdx + "_tw_" + sexSuffix + "_video.mp4";
    else if (currentLang === "tc-CN")
      vName =
        VIDEO_URL + "/" + dateStr + viewIdx + "_tc_" + sexSuffix + "_video.mp4";
    else
      vName =
        VIDEO_URL + "/" + dateStr + viewIdx + "_" + sexSuffix + "_video.mp4";
    setVideoName(vName);

    if (viewData || formVals) {
      const getVal = (fKey, vKey) => {
        if (formVals && formVals[fKey] !== undefined) return formVals[fKey];
        if (viewData && viewData[vKey] !== undefined) return viewData[vKey];
        return "";
      };

      const rawCcy1 =
        currentLang === "en"
          ? getVal("eng_ccy1", "eng_ccy1") || getVal("ccy1", "ccy1")
          : currentLang === "yue-CN"
            ? getVal("tw_ccy1", "tw_ccy1") || getVal("tc_ccy1", "tc_ccy1") || getVal("ccy1", "ccy1")
            : currentLang === "tc-CN"
              ? getVal("tc_ccy1", "tc_ccy1") || getVal("tw_ccy1", "tw_ccy1") || getVal("ccy1", "ccy1")
              : getVal("ccy1", "ccy1") || getVal("eng_ccy1", "eng_ccy1");

      const rawCcy2 =
        currentLang === "en"
          ? getVal("eng_ccy2", "eng_ccy2") || getVal("ccy2", "ccy2")
          : currentLang === "yue-CN"
            ? getVal("tw_ccy2", "tw_ccy2") || getVal("tc_ccy2", "tc_ccy2") || getVal("ccy2", "ccy2")
            : currentLang === "tc-CN"
              ? getVal("tc_ccy2", "tc_ccy2") || getVal("tw_ccy2", "tw_ccy2") || getVal("ccy2", "ccy2")
              : getVal("ccy2", "ccy2") || getVal("eng_ccy2", "eng_ccy2");

      const pairParts = (viewData?.ccypair || "").split("/");
      const ccy1 = rawCcy1 || pairParts[0] || "";
      const ccy2 = rawCcy2 || pairParts[1] || "";

      const viewLabel =
        currentLang === "en"
          ? getVal("eng_cnview", "view")
          : currentLang === "yue-CN"
            ? getVal("tw_cnview", "twview")
            : currentLang === "tc-CN"
              ? getVal("tc_cnview", "tcview")
              : getVal("cnview", "cnview");

      const entryVal = formVals ? formVals.entry : viewData.entry || "";
      const neutralVal = formVals ? formVals.neutral : viewData.neutral || "";
      const expectVal = formVals ? formVals.expect : viewData.expect || "";

      const msg1_1 = formVals
        ? currentLang === "en"
          ? formVals.amended_eng_msg1_1
          : currentLang === "yue-CN"
            ? formVals.amended_tw_msg1_1
            : currentLang === "tc-CN"
              ? formVals.amended_tc_msg1_1
              : formVals.amended_msg1_1
        : viewData
          ? currentLang === "en"
            ? viewData.amended_eng_msg1 || viewData.eng_msg1
            : currentLang === "yue-CN"
              ? viewData.amended_tw_msg1 || viewData.tw_msg1
              : currentLang === "tc-CN"
                ? viewData.amended_tc_msg1 || viewData.tc_msg1
                : viewData.amended_msg1 || viewData.msg1
          : "";

      const msg1_2 = formVals
        ? currentLang === "en"
          ? formVals.amended_eng_msg1_2
          : currentLang === "yue-CN"
            ? formVals.amended_tw_msg1_2
            : currentLang === "tc-CN"
              ? formVals.amended_tc_msg1_2
              : formVals.amended_msg1_2
        : "";

      const msg2 = formVals
        ? currentLang === "en"
          ? formVals.amended_eng_msg2
          : currentLang === "yue-CN"
            ? formVals.amended_tw_msg2
            : currentLang === "tc-CN"
              ? formVals.amended_tc_msg2
              : formVals.amended_msg2
        : viewData
          ? currentLang === "en"
            ? viewData.amended_eng_msg2 || viewData.eng_msg2
            : currentLang === "yue-CN"
              ? viewData.amended_tw_msg2 || viewData.tw_msg2
              : currentLang === "tc-CN"
                ? viewData.amended_tc_msg2 || viewData.tc_msg2
                : viewData.amended_msg2 || viewData.msg2
          : "";

      const bgColor = currentLang === "tc-CN" ? "#030a44" : "#0c55a9";

      const newPreviewProps = {
        title:
          ccy1 || ccy2
            ? `${ccy1 || ""} / ${ccy2 || ""} (${viewLabel || ""})`
            : "SCB Daily Navigator",
        subtitle: `Entry: ${entryVal} | Neutral: ${neutralVal} | Expect: ${expectVal}`,
        color: bgColor,
        backgroundColor: bgColor,
      };

      setPreviewProps(newPreviewProps);

      const parsedBullish = parseFloat(entryVal);
      const parsedNeutral = parseFloat(neutralVal);
      const parsedTarget = parseFloat(expectVal);

      const langAudioSuffix =
        currentLang === "en"
          ? `_en_${sexSuffix}_`
          : currentLang === "yue-CN"
            ? `_tw_${sexSuffix}_`
            : currentLang === "tc-CN"
              ? `_tc_${sexSuffix}_`
              : `_${sexSuffix}_`;

      const v = version !== undefined ? version : audioVersion;
      const vQuery = v ? `?v=${v}` : "";

      const newAudioList = [];
      if (msg1_1 && msg1_1.trim()) {
        newAudioList.push({
          src: `${VIDEO_URL}/audio/${dateStr || "20260101"}${viewIdx}${langAudioSuffix}msg1A.mp3${vQuery}`,
          message: msg1_1.trim(),
        });
      }
      if (msg1_2 && msg1_2.trim()) {
        newAudioList.push({
          src: `${VIDEO_URL}/audio/${dateStr || "20260101"}${viewIdx}${langAudioSuffix}msg1B.mp3${vQuery}`,
          message: msg1_2.trim(),
        });
      }
      if (msg2 && msg2.trim()) {
        newAudioList.push({
          src: `${VIDEO_URL}/audio/${dateStr || "20260101"}${viewIdx}${langAudioSuffix}msg2.mp3${vQuery}`,
          message: msg2.trim(),
        });
      }
      if (newAudioList.length === 0) {
        newAudioList.push({
          src: `${VIDEO_URL}/audio/${dateStr || "20260101"}${viewIdx}${langAudioSuffix}msg1A.mp3${vQuery}`,
          message: msg1_1 || "",
        });
      }

      const generatedVideoProps = {
        ...newPreviewProps,
        date: dateStr || input_date || "20260422",
        lang: currentLang,
        sex: activeSex,
        color: bgColor,
        backgroundColor: bgColor,
        entry: entryVal,
        neutral: neutralVal,
        expect: expectVal,
        bullishNumber: !isNaN(parsedBullish) ? parsedBullish : 1.301,
        turnNeutral: !isNaN(parsedNeutral) ? parsedNeutral : 1.375,
        targetLevel: !isNaN(parsedTarget) ? parsedTarget : 1.354,
        ccy1: ccy1 || "",
        ccy2: ccy2 || "",
        firstUnit: ccy1 || "",
        secondUnit: ccy2 || "",
        cnview: viewLabel || "",
        msg1_1: msg1_1 || "",
        msg1_2: msg1_2 || "",
        msg2: msg2 || "",
        audioList: newAudioList,
        icon1:
          viewData?.icon1 ||
          (viewData?.icons && viewData.icons[0]) ||
          formVals?.icon1 ||
          "sc_icon_analysis1_full-colour_rgb_1600px.svg",
        icon2:
          viewData?.icon2 ||
          (viewData?.icons && viewData.icons[1]) ||
          formVals?.icon2 ||
          "sc_icon_growth-1_full-colour_rgb_1600px.svg",
        icon3:
          viewData?.icon3 ||
          (viewData?.icons && viewData.icons[2]) ||
          formVals?.icon3 ||
          "sc_icon_stock-market-1_full-colour_rgb_1600px.svg",
        icons: [
          viewData?.icon1 ||
            (viewData?.icons && viewData.icons[0]) ||
            formVals?.icon1 ||
            "sc_icon_analysis1_full-colour_rgb_1600px.svg",
          viewData?.icon2 ||
            (viewData?.icons && viewData.icons[1]) ||
            formVals?.icon2 ||
            "sc_icon_growth-1_full-colour_rgb_1600px.svg",
          viewData?.icon3 ||
            (viewData?.icons && viewData.icons[2]) ||
            formVals?.icon3 ||
            "sc_icon_stock-market-1_full-colour_rgb_1600px.svg",
        ],
      };

      setVideoProps(generatedVideoProps);
      return generatedVideoProps;
    }
  };

  const StartCheckStatus = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      CheckStatus();
    }, 20000);
  };

  const CheckStatus = () => {
    const statusLang = lang === "en" ? "en-US" : lang;
    const dateVal = input_date || "20260101";
    fetch(VIDEO_URL + "/api2?status=" + statusLang + dateVal + input_view)
      .then((response) => response.json())
      .then((result) => {
        let res = result.status;
        if (res === "complete") {
          if (intervalRef.current) clearInterval(intervalRef.current);
          toast.info("Video rendering completed!");
        }
      })
      .catch((err) => {
        console.log("CheckStatus error:", err.message);
      });
  };

  const LogoutButton = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const ChangePasswordButton = () => {
    window.location.href = "/ChangePassword";
  };

  const triggerManualS3Download = (url, name) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = name || "video.mp4";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const addCacheBuster = (url) => {
    if (!url) return url;
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}t=${Date.now()}`;
  };

  const syncViewDataFromForm = (formData, viewsArray, targetIdx, activeSex) => {
    if (!viewsArray || !viewsArray[targetIdx]) return viewsArray;
    const viewsCopy = [...viewsArray];
    const targetView = { ...viewsCopy[targetIdx] };

    if (formData.expect !== undefined) targetView.expect = formData.expect;
    if (formData.entry !== undefined) targetView.entry = formData.entry;
    if (formData.neutral !== undefined) targetView.neutral = formData.neutral;

    if (formData.ccy1 !== undefined) targetView.ccy1 = formData.ccy1;
    if (formData.ccy2 !== undefined) targetView.ccy2 = formData.ccy2;
    if (formData.cnview !== undefined) targetView.cnview = formData.cnview;
    if (formData.amended_msg1_1 !== undefined) {
      targetView.amended_msg1 =
        (formData.amended_msg1_1 || "") +
        ((formData.amended_msg1_1 || "").slice(-1) === "。" ? "" : "。") +
        (formData.amended_msg1_2 || "");
    }
    if (formData.amended_msg2 !== undefined) {
      targetView.amended_msg2 = formData.amended_msg2;
    }

    if (formData.eng_ccy1 !== undefined)
      targetView.eng_ccy1 = formData.eng_ccy1;
    if (formData.eng_ccy2 !== undefined)
      targetView.eng_ccy2 = formData.eng_ccy2;
    if (formData.eng_cnview !== undefined)
      targetView.view = formData.eng_cnview;
    if (formData.amended_eng_msg1_1 !== undefined) {
      targetView.amended_eng_msg1 =
        (formData.amended_eng_msg1_1 || "") +
        ((formData.amended_eng_msg1_1 || "").slice(-2) === ". "
          ? ""
          : (formData.amended_eng_msg1_1 || "").slice(-1) === "."
            ? " "
            : ". ") +
        (formData.amended_eng_msg1_2 || "");
    }
    if (formData.amended_eng_msg2 !== undefined) {
      targetView.amended_eng_msg2 = formData.amended_eng_msg2;
    }

    if (formData.tw_ccy1 !== undefined) targetView.tw_ccy1 = formData.tw_ccy1;
    if (formData.tw_ccy2 !== undefined) targetView.tw_ccy2 = formData.tw_ccy2;
    if (formData.tw_cnview !== undefined)
      targetView.twview = formData.tw_cnview;
    if (formData.amended_tw_msg1_1 !== undefined) {
      targetView.amended_tw_msg1 =
        (formData.amended_tw_msg1_1 || "") +
        ((formData.amended_tw_msg1_1 || "").slice(-1) === "。" ? "" : "。") +
        (formData.amended_tw_msg1_2 || "");
    }
    if (formData.amended_tw_msg2 !== undefined) {
      targetView.amended_tw_msg2 = formData.amended_tw_msg2;
    }

    if (formData.tc_ccy1 !== undefined) targetView.tc_ccy1 = formData.tc_ccy1;
    if (formData.tc_ccy2 !== undefined) targetView.tc_ccy2 = formData.tc_ccy2;
    if (formData.tc_cnview !== undefined)
      targetView.tcview = formData.tc_cnview;
    if (formData.amended_tc_msg1_1 !== undefined) {
      targetView.amended_tc_msg1 =
        (formData.amended_tc_msg1_1 || "") +
        ((formData.amended_tc_msg1_1 || "").slice(-1) === "。" ? "" : "。") +
        (formData.amended_tc_msg1_2 || "");
    }
    if (formData.amended_tc_msg2 !== undefined) {
      targetView.amended_tc_msg2 = formData.amended_tc_msg2;
    }

    const currentVoiceSex = activeSex || sex || "Male";
    if (formData.voice) targetView.voice = formData.voice;
    if (formData.eng_voice) targetView.eng_voice = formData.eng_voice;
    if (formData.tw_voice) targetView.tw_voice = formData.tw_voice;
    if (formData.tc_voice) targetView.tc_voice = formData.tc_voice;

    if (lang === "en") {
      targetView.eng_voice = currentVoiceSex;
    } else if (lang === "yue-CN") {
      targetView.tw_voice = currentVoiceSex;
    } else if (lang === "tc-CN") {
      targetView.tc_voice = currentVoiceSex;
    } else {
      targetView.voice = currentVoiceSex;
    }

    const fixedIcon1 =
      targetView.icon1 ||
      (targetView.icons && targetView.icons[0]) ||
      formData.icon1 ||
      "sc_icon_analysis1_full-colour_rgb_1600px.svg";
    const fixedIcon2 =
      targetView.icon2 ||
      (targetView.icons && targetView.icons[1]) ||
      formData.icon2 ||
      "sc_icon_growth-1_full-colour_rgb_1600px.svg";
    const fixedIcon3 =
      targetView.icon3 ||
      (targetView.icons && targetView.icons[2]) ||
      formData.icon3 ||
      "sc_icon_stock-market-1_full-colour_rgb_1600px.svg";

    targetView.icon1 = fixedIcon1;
    targetView.icon2 = fixedIcon2;
    targetView.icon3 = fixedIcon3;
    targetView.icons = [fixedIcon1, fixedIcon2, fixedIcon3];

    viewsCopy[targetIdx] = targetView;
    return viewsCopy;
  };

  const copyToClipboard = (text) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => toast.success("Video link copied to clipboard!"))
        .catch(() => {
          fallbackCopyTextToClipboard(text);
        });
    } else {
      fallbackCopyTextToClipboard(text);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Video link copied to clipboard!");
      } else {
        toast.error("Failed to copy link. Please copy manually: " + text);
      }
    } catch (err) {
      toast.error("Failed to copy link: " + (err.message || text));
    }
  };

  const handleGetLink = () => {
    if (!videoLink) {
      toast.warn(
        "No video link available for this view yet. Please click Generate first.",
      );
      return;
    }
    copyToClipboard(videoLink);
  };

  const fetchVideoLink = (dateVal, viewIdx, langVal, sexVal) => {
    const d = dateVal || input_date || "20260101";
    const v = viewIdx !== undefined ? viewIdx : input_view;
    const l = langVal || lang;
    const s = sexVal || sex || "Male";
    const statusLang = l === "en" ? "en-US" : l;
    const statusKey = `${statusLang}${d}${v}`;

    fetch(
      `${API_BASE_URL}/api/video-status?statusKey=${encodeURIComponent(statusKey)}&sex=${encodeURIComponent(s)}`,
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.status === "200" && result.link) {
          const freshLink = addCacheBuster(result.link);
          setVideoLink(freshLink);
          setS3DownloadInfo({
            downloadUrl: freshLink,
            s3Key:
              result.s3Key ||
              `videos/${d}/${d}_${l}_view${v}_${s.toLowerCase()}.mp4`,
            filename:
              result.filename || `${d}_${l}_view${v}_${s.toLowerCase()}.mp4`,
          });
        } else {
          setVideoLink("");
          setS3DownloadInfo(null);
        }
      })
      .catch((err) => {
        console.log("fetchVideoLink error:", err.message);
        setVideoLink("");
        setS3DownloadInfo(null);
      });
  };

  const pollVideoRenderStatus = async (
    statusKey,
    dateVal,
    filename,
    toastId,
    initialData = {},
    targetSex = sex,
  ) => {
    const maxPolls = 120; // 5 minutes max (120 * 2.5s)
    let polls = 0;
    const renderId = initialData.renderId;
    const bucketName = initialData.bucketName || "labci-scb-hcivideo-uat";
    const sexVal = initialData.sex || targetSex || sex || "Male";

    if (renderId) {
      updateActiveRender(statusKey, {
        renderId,
        bucketName,
        dateVal,
        filename,
        progress: 0,
        startTime: Date.now(),
        sex: sexVal,
      });
    }

    if (toastId) {
      toast.update(toastId, {
        render:
          "Video rendering in progress on AWS Lambda (checking status)...",
        type: "info",
        isLoading: true,
      });
    }

    return new Promise((resolve, reject) => {
      const pollInterval = setInterval(async () => {
        polls++;
        try {
          let progData = null;

          // 1. Direct Lambda progress check using authoritative renderId
          if (renderId && bucketName) {
            try {
              const progRes = await fetch(
                `${API_BASE_URL}/api/lambda-progress?renderId=${encodeURIComponent(renderId)}&bucketName=${encodeURIComponent(bucketName)}&statusKey=${encodeURIComponent(statusKey)}&filename=${encodeURIComponent(filename)}&date=${encodeURIComponent(dateVal)}&lang=${encodeURIComponent(lang)}&sex=${encodeURIComponent(sexVal)}`,
              );
              if (progRes.ok) {
                progData = await progRes.json();
              }
            } catch (_) {}
          }

          // 2. Secondary check from DynamoDB if lambda-progress was unavailable
          if (!progData) {
            try {
              const statusRes = await fetch(
                `${API_BASE_URL}/api/video-status?statusKey=${encodeURIComponent(statusKey)}&sex=${encodeURIComponent(sexVal)}`,
              );
              if (statusRes.ok) {
                progData = await statusRes.json();
              }
            } catch (statusErr) {
              console.log("DynamoDB status check error:", statusErr.message);
            }
          }

          // 3. Check if video rendering is complete
          if (
            progData &&
            (progData.done ||
              progData.renderStatus === "complete" ||
              (progData.link && progData.link.length > 0) ||
              (progData.downloadUrl && progData.downloadUrl.length > 0))
          ) {
            clearInterval(pollInterval);
            setIsExporting(false);
            updateActiveRender(statusKey, null); // remove from active renders

            const finalUrl = progData.link || progData.downloadUrl;
            if (finalUrl) {
              const cacheBustedUrl = addCacheBuster(finalUrl);
              const activeStatusLang = lang === "en" ? "en-US" : lang;
              const activeKey = `${activeStatusLang}${input_date || "20260101"}${input_view}`;
              if (
                statusKey === activeKey &&
                (!sex || sexVal.toLowerCase() === sex.toLowerCase())
              ) {
                setVideoLink(cacheBustedUrl);
                setS3DownloadInfo({
                  downloadUrl: cacheBustedUrl,
                  s3Key: progData.s3Key || `videos/${dateVal}/${filename}`,
                  filename: initialData.filename || filename,
                });
                reset(getValues());
              }
            }
            if (toastId) {
              toast.update(toastId, {
                render:
                  "Audio & video generated on AWS Lambda! Click 'Download' to copy the link.",
                type: "success",
                isLoading: false,
                autoClose: 4000,
              });
            }
            return resolve();
          }

          // 4. Check if rendering encountered a fatal error
          if (
            progData &&
            (progData.renderStatus === "failed" ||
              progData.fatalErrorEncountered)
          ) {
            clearInterval(pollInterval);
            setIsExporting(false);
            updateActiveRender(statusKey, null);
            if (toastId) {
              toast.update(toastId, {
                render: "AWS Lambda video rendering encountered an error.",
                type: "error",
                isLoading: false,
                autoClose: 5000,
              });
            }
            return reject(new Error("AWS Lambda video rendering failed."));
          }

          // 5. Update active render progress in state & update toast
          const progressPercent =
            progData && typeof progData.progress === "number"
              ? progData.progress
              : Math.min(95, Math.round((polls / maxPolls) * 100));

          updateActiveRender(statusKey, {
            progress: progressPercent,
            sex: sexVal,
          });

          const elapsedSec = Math.round(polls * 2.5);
          if (toastId) {
            toast.update(toastId, {
              render: `Rendering video on AWS Lambda... (${progressPercent}%) (${elapsedSec}s elapsed)`,
              type: "info",
              isLoading: true,
            });
          }
        } catch (pollErr) {
          console.log("Status poll error:", pollErr);
        }

        // 6. Max timeout threshold check
        if (polls >= maxPolls) {
          clearInterval(pollInterval);
          setIsExporting(false);
          updateActiveRender(statusKey, null);
          if (toastId) {
            toast.update(toastId, {
              render:
                "Rendering is continuing on AWS Lambda in the background. Use 'Download' in a moment to fetch the link.",
              type: "info",
              isLoading: false,
              autoClose: 6000,
            });
          }
          resolve();
        }
      }, 2500);
    });
  };

  const exportVideo = async (customVideoProps, existingToastId, activeSex) => {
    setIsExporting(true);
    const toastId =
      existingToastId ||
      toast.loading("Initiating video render on AWS Lambda, please wait...");
    const dateVal = input_date || "20260101";
    const currentSex = activeSex || sex || "Male";
    const sexSuffix = `_${currentSex.toLowerCase()}`;
    const filename = `${dateVal}_${lang}_view${input_view}${sexSuffix}.mp4`;
    const statusLang = lang === "en" ? "en-US" : lang;
    const statusKey = `${statusLang}${dateVal}${input_view}`;

    try {
      const token = localStorage.getItem("token") || "";
      const propsToSend = customVideoProps || videoProps;

      let response = null;
      try {
        response = await fetch(
          `${API_BASE_URL}/api/export-video?token=${encodeURIComponent(token)}&rebuild=true`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              filename,
              date: dateVal,
              lang,
              view: input_view,
              sex: currentSex,
              inputProps: {
                ...propsToSend,
                sex: currentSex,
              },
              rebuild: true,
            }),
          },
        );
      } catch (networkErr) {
        console.warn(
          "Network or Gateway timeout during export dispatch, transitioning to background polling:",
          networkErr,
        );
        // If HTTP connection was dropped by gateway/proxy timeout, Lambda is likely still running in background
        return await pollVideoRenderStatus(
          statusKey,
          dateVal,
          filename,
          toastId,
          {},
          currentSex,
        );
      }

      if (!response.ok) {
        // If 504 Gateway Timeout or 502 Bad Gateway, gracefully fall back to polling DynamoDB status
        if (response.status === 504 || response.status === 502) {
          console.warn(
            `HTTP ${response.status} from gateway, polling background render status...`,
          );
          return await pollVideoRenderStatus(
            statusKey,
            dateVal,
            filename,
            toastId,
            {},
            currentSex,
          );
        }

        let errMessage = `Export failed with status ${response.status}`;
        try {
          const errData = await response.json();
          if (errData.error || errData.msg) {
            errMessage = errData.error || errData.msg;
          }
        } catch (_) {}
        throw new Error(errMessage);
      }

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        if (data.token) {
          localStorage.setItem("token", data.token);
        }

        // 1. Remotion Lambda Asynchronous Rendering Mode or In-Progress status
        if (
          data.mode === "lambda" ||
          data.renderStatus === "rendering" ||
          (data.status === "200" && !data.downloadUrl && !data.link)
        ) {
          const resolvedStatusKey = data.statusKey || statusKey;
          return await pollVideoRenderStatus(
            resolvedStatusKey,
            dateVal,
            filename,
            toastId,
            data,
            currentSex,
          );
        }

        // 2. Direct S3 download URL returned immediately
        if (data.downloadUrl || data.link) {
          const finalUrl = data.downloadUrl || data.link;
          const cacheBustedUrl = addCacheBuster(finalUrl);
          if (currentSex.toLowerCase() === (sex || "").toLowerCase()) {
            setVideoLink(cacheBustedUrl);
            setS3DownloadInfo({
              downloadUrl: cacheBustedUrl,
              s3Key: data.s3Key || `videos/${dateVal}/${filename}`,
              filename: data.filename || filename,
              size: data.size,
            });
            reset(getValues());
          }

          toast.update(toastId, {
            render:
              "Audio & video generated and uploaded to S3! Click 'Download' to copy the link.",
            type: "success",
            isLoading: false,
            autoClose: 4000,
          });
          return;
        }
      }

      // Fallback if binary stream was received
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      toast.update(toastId, {
        render: "Audio & video generated and downloaded successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (err) {
      console.error("Export error:", err);
      toast.update(toastId, {
        render: `Failed to export video: ${err.message || "Unknown error"}`,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      throw err;
    } finally {
      setIsExporting(false);
    }
  };

  const HandleDateSelector = (date) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setInputDate(date);
    setLoadingStatus(false);

    fetch(
      API_BASE_URL +
        "/api/getjson?token=" +
        localStorage.getItem("token") +
        "&date=" +
        date,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          localStorage.setItem("token", result.token);
          setInputJSON(result.data);

          if (
            result.data &&
            result.data.views &&
            result.data.views.length > 0
          ) {
            setView(0);
            setInputActive(result.data.views[0].status === "Open");
            populateFormData(result.data.views[0], date, 0, lang);
          } else {
            setInputJSON([]);
            setInputActive(false);
            reset({});
            updateVideoUrlAndPreview(
              date,
              0,
              lang,
              null,
              null,
              audioVersion,
              sex,
            );
          }
        } else {
          window.location.href = "/";
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const HandleViewsSelector = (index) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    document.activeElement?.blur && document.activeElement.blur();

    const idx = parseInt(index, 10) || 0;
    setView(idx);

    if (input_json && input_json.views && input_json.views[idx]) {
      const selectedView = input_json.views[idx];
      setInputActive(selectedView.status === "Open");
      populateFormData(selectedView, input_date, idx, lang);
    }
  };

  const ConfirmModal = (type, data) => {
    setTempType(type);
    setTempSelectedOption(data);

    if (isDirty) {
      setDeleteModalShow(true);
    } else {
      if (type === "date") HandleDateSelector(data);
      else if (type === "view") HandleViewsSelector(data);
      else if (type === "lang") handleLangChange(data);
    }
  };

  const DeleteModalConfirmHandle = () => {
    setDeleteModalShow(false);

    if (temptype === "date") HandleDateSelector(tempselectedoption);
    else if (temptype === "view") HandleViewsSelector(tempselectedoption);
    else if (temptype === "lang") handleLangChange(tempselectedoption);
  };

  const currentStatusLang = lang === "en" ? "en-US" : lang;
  const currentStatusKey = `${currentStatusLang}${input_date || "20260101"}${input_view}`;
  const currentActiveRender = activeRenders[currentStatusKey];
  const isCurrentViewRendering = Boolean(currentActiveRender);
  const isGeneratingCurrent =
    loadingstatus || isExporting || isCurrentViewRendering;
  const renderPercentStr =
    currentActiveRender?.progress !== undefined &&
    currentActiveRender?.progress !== null
      ? `${currentActiveRender.progress}%`
      : "";
  const generateBtnText = loadingstatus
    ? "Generating..."
    : isExporting
      ? "Dispatching..."
      : isCurrentViewRendering
        ? `Rendering ${renderPercentStr ? `(${renderPercentStr})` : "..."}`
        : "Generate";

  const GenerateButton = async () => {
    if (loadingstatus || isExporting || isCurrentViewRendering) return;
    setLoadingStatus(true);
    const toastId = toast.loading(
      "Saving updates & generating audio, please wait...",
    );
    try {
      const dateVal = input_date || "20260101";
      const formVals = getValues();

      // 1. Sync current form values (subtitles, ccy, targets, voice) into input_json
      let updatedViews = input_json?.views || [];
      if (input_json && input_json.views && input_json.views[input_view]) {
        updatedViews = syncViewDataFromForm(
          formVals,
          input_json.views,
          input_view,
          sex,
        );
        const updatedJson = { ...input_json, views: updatedViews };
        setInputJSON(updatedJson);

        // 2. Persist updated subtitles to DynamoDB / backend so TTS audio generates from latest text
        const payload = {
          date: dateVal,
          data: JSON.stringify(updatedJson),
          token: localStorage.getItem("token") || "",
        };
        try {
          const saveRes = await fetch(API_BASE_URL + "/api/savejson2", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload),
          });
          if (saveRes.ok) {
            const resData = await saveRes.json().catch(() => ({}));
            if (resData.status === "200" && resData.token) {
              localStorage.setItem("token", resData.token);
            }
          }
        } catch (err) {
          console.log("Save voice/subtitles error:", err);
        }
      }

      // 3. Generate Audio using backend api2
      const response = await fetch(
        VIDEO_URL +
          "/api2?date=" +
          dateVal +
          "&view=" +
          input_view +
          "&lang=" +
          lang +
          "&sex=" +
          sex,
      );

      if (!response.ok) {
        throw new Error(
          `Audio generation failed with status ${response.status}`,
        );
      }

      await response.json().catch(() => ({}));

      // 4. Update preview and video props with timestamped audio and updated subtitles
      const newVersion = Date.now();
      setAudioVersion(newVersion);
      triggerVideoLoading();

      const targetCurrentView =
        updatedViews[input_view] || input_json?.views?.[input_view];
      const updatedVideoProps = updateVideoUrlAndPreview(
        dateVal,
        input_view,
        lang,
        targetCurrentView,
        formVals,
        newVersion,
        sex,
      );

      StartCheckStatus();

      toast.update(toastId, {
        render: "Audio generated! Now rendering video and uploading to S3...",
        type: "info",
        isLoading: true,
      });

      // 5. Render video on Lambda / server and upload new video to S3
      await exportVideo(updatedVideoProps, toastId, sex);
      reset(formVals);
    } catch (err) {
      console.error("Generate error:", err);
      toast.update(toastId, {
        render: `Failed: ${err.message || "Fail to generate the video"}`,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setLoadingStatus(false);
    }
  };

  const populateFormData = (viewData, dateStr, viewIdx, currentLang) => {
    if (!viewData) return;

    let twMsg1 = ["", ""];
    if (viewData.hasOwnProperty("twview")) {
      twMsg1 = splitCn(
        viewData.amended_tw_msg1 !== ""
          ? viewData.amended_tw_msg1
          : viewData.tw_msg1,
      );
    } else {
      twMsg1 = splitCn(
        viewData.amended_msg1 !== "" ? viewData.amended_msg1 : viewData.msg1,
      );
    }
    const twMsg2 = viewData.hasOwnProperty("twview")
      ? viewData.amended_tw_msg2 !== ""
        ? viewData.amended_tw_msg2
        : viewData.tw_msg2
      : viewData.amended_msg2 !== ""
        ? viewData.amended_msg2
        : viewData.msg2;

    let tcMsg1 = ["", ""];
    if (viewData.hasOwnProperty("tcview")) {
      tcMsg1 = splitCn(
        viewData.amended_tc_msg1 !== ""
          ? viewData.amended_tc_msg1
          : viewData.tc_msg1,
      );
    } else {
      tcMsg1 = splitCn(
        viewData.amended_msg1 !== "" ? viewData.amended_msg1 : viewData.msg1,
      );
    }
    const tcMsg2 = viewData.hasOwnProperty("tcview")
      ? viewData.amended_tc_msg2 !== ""
        ? viewData.amended_tc_msg2
        : viewData.tc_msg2
      : viewData.amended_msg2 !== ""
        ? viewData.amended_msg2
        : viewData.msg2;

    const cnMsg1 = splitCn(
      viewData.amended_msg1 !== "" ? viewData.amended_msg1 : viewData.msg1,
    );
    const cnMsg2 =
      viewData.amended_msg2 !== "" ? viewData.amended_msg2 : viewData.msg2;

    const engMsg1 = splitEn(
      viewData.amended_eng_msg1 !== ""
        ? viewData.amended_eng_msg1
        : viewData.eng_msg1,
    );
    const engMsg2 =
      viewData.amended_eng_msg2 !== ""
        ? viewData.amended_eng_msg2
        : viewData.eng_msg2;

    const currentVoice =
      currentLang === "en"
        ? viewData.eng_voice || "Male"
        : currentLang === "yue-CN"
          ? viewData.tw_voice || "Male"
          : currentLang === "tc-CN"
            ? viewData.tc_voice || "Male"
            : viewData.voice || "Male";
    setSex(currentVoice);

    const pairParts = (viewData.ccypair || "").split("/");
    const fallbackCcy1 = pairParts[0] || "";
    const fallbackCcy2 = pairParts[1] || "";

    const newValues = {
      entry: viewData.entry || "",
      neutral: viewData.neutral || "",
      expect: viewData.expect || "",
      ccy1: viewData.ccy1 || fallbackCcy1 || "",
      ccy2: viewData.ccy2 || fallbackCcy2 || "",
      cnview: viewData.cnview || "",
      voice: viewData.voice || "Male",
      amended_msg1_1: cnMsg1[0],
      amended_msg1_2: cnMsg1[1],
      amended_msg2: cnMsg2 || "",
      eng_ccy1: viewData.eng_ccy1 || fallbackCcy1 || viewData.ccy1 || "",
      eng_ccy2: viewData.eng_ccy2 || fallbackCcy2 || viewData.ccy2 || "",
      eng_cnview: viewData.view || "",
      eng_voice: viewData.eng_voice || "Male",
      amended_eng_msg1_1: engMsg1[0],
      amended_eng_msg1_2: engMsg1[1],
      amended_eng_msg2: engMsg2 || "",
      tw_ccy1: viewData.tw_ccy1 || viewData.tc_ccy1 || viewData.ccy1 || fallbackCcy1 || "",
      tw_ccy2: viewData.tw_ccy2 || viewData.tc_ccy2 || viewData.ccy2 || fallbackCcy2 || "",
      tw_cnview: viewData.twview || "",
      tw_voice: viewData.tw_voice || "Male",
      amended_tw_msg1_1: twMsg1[0],
      amended_tw_msg1_2: twMsg1[1],
      amended_tw_msg2: twMsg2 || "",
      tc_ccy1: viewData.tc_ccy1 || viewData.tw_ccy1 || viewData.ccy1 || fallbackCcy1 || "",
      tc_ccy2: viewData.tc_ccy2 || viewData.tw_ccy2 || viewData.ccy2 || fallbackCcy2 || "",
      tc_cnview: viewData.tcview || "",
      tc_voice: viewData.tc_voice || "Male",
      amended_tc_msg1_1: tcMsg1[0],
      amended_tc_msg1_2: tcMsg1[1],
      amended_tc_msg2: tcMsg2 || "",
      icon1: (
        viewData.icon1 ||
        (viewData.icons && viewData.icons[0]) ||
        "sc_icon_analysis1_full-colour_rgb_1600px.svg"
      ).replace(/\.png$/i, ".svg"),
      icon2: (
        viewData.icon2 ||
        (viewData.icons && viewData.icons[1]) ||
        "sc_icon_growth-1_full-colour_rgb_1600px.svg"
      ).replace(/\.png$/i, ".svg"),
      icon3: (
        viewData.icon3 ||
        (viewData.icons && viewData.icons[2]) ||
        "sc_icon_stock-market-1_full-colour_rgb_1600px.svg"
      ).replace(/\.png$/i, ".svg"),
    };

    reset(newValues);
    fetchVideoLink(dateStr, viewIdx, currentLang, currentVoice);
    updateVideoUrlAndPreview(
      dateStr,
      viewIdx,
      currentLang,
      viewData,
      newValues,
      audioVersion,
      currentVoice,
    );
  };

  const handleSexChange = async (newSex) => {
    setSex(newSex);
    const voiceField =
      lang === "en"
        ? "eng_voice"
        : lang === "yue-CN"
          ? "tw_voice"
          : lang === "tc-CN"
            ? "tc_voice"
            : "voice";

    // Update in-memory views JSON immediately
    if (input_json && input_json.views && input_json.views[input_view]) {
      input_json.views[input_view][voiceField] = newSex;
      setInputJSON({ ...input_json });
    }

    // Keep react-hook-form in sync without forcing dirty state
    if (!isDirty) {
      const currentValues = getValues();
      currentValues[voiceField] = newSex;
      reset(currentValues);
    } else {
      setValue(voiceField, newSex, { shouldDirty: false });
    }

    // Immediately query DB for video of this gender: visible button / update link
    fetchVideoLink(input_date, input_view, lang, newSex);

    // Update audio preview & video props to match the new gender
    const currentViewData =
      input_json && input_json.views && input_json.views[input_view]
        ? input_json.views[input_view]
        : null;
    updateVideoUrlAndPreview(
      input_date,
      input_view,
      lang,
      currentViewData,
      getValues(),
      audioVersion,
      newSex,
    );

    triggerVideoLoading();

    const token = localStorage.getItem("token") || "";
    const dateVal = input_date || "20260101";

    try {
      const response = await fetch(`${API_BASE_URL}/api/update-voice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          date: dateVal,
          view: input_view,
          voice: newSex,
          lang,
          voiceField,
        }),
      });

      const resData = await response.json();
      if (resData.status === "200") {
        if (resData.token) {
          localStorage.setItem("token", resData.token);
        }
        toast.success(`Voice updated to ${newSex}!`, { autoClose: 2000 });
      } else {
        console.error("Failed to update voice in DB:", resData);
        toast.error(resData.msg || "Failed to update voice");
      }
    } catch (err) {
      console.error("Voice update network error:", err);
      toast.error("Failed to update voice due to network error");
    }
  };

  const HandleUpdate = (data) => {
    if (!input_json || !input_json.views || !input_json.views[input_view])
      return;

    console.log("submit", data);
    const updatedViews = syncViewDataFromForm(
      data,
      input_json.views,
      input_view,
      sex,
    );
    const updatedJson = { ...input_json, views: updatedViews };
    setInputJSON(updatedJson);

    const payload = {
      date: input_date || "20260101",
      data: JSON.stringify(updatedJson),
      token: localStorage.getItem("token") || "",
    };

    fetch(API_BASE_URL + "/api/savejson2", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(payload),
    })
      .then((response) => response.json())
      .then((resData) => {
        if (resData.status === "200") {
          localStorage.setItem("token", resData.token);
          toast.success("Updated successfully!");
          reset(data);
          triggerVideoLoading();
          updateVideoUrlAndPreview(
            input_date,
            input_view,
            lang,
            updatedViews[input_view],
            data,
            audioVersion,
            sex,
          );
        } else {
          console.log("Update error response:", resData);
          toast.error(resData.msg || "Failed to update");
        }
      })
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to update");
      });
  };

  const handleLangChange = (newLang) => {
    triggerVideoLoading();
    setLang(newLang);
    if (input_json && input_json.views && input_json.views[input_view]) {
      const currentViewData = input_json.views[input_view];
      populateFormData(currentViewData, input_date, input_view, newLang);
    } else {
      reset({});
      updateVideoUrlAndPreview(
        input_date,
        input_view,
        newLang,
        null,
        null,
        audioVersion,
        sex,
      );
    }
  };

  const renderFieldGroup = (disabled) => {
    const isEn = lang === "en";
    const isYue = lang === "yue-CN";
    const isTc = lang === "tc-CN";
    const isCn = lang === "zn-CN";

    const labels = {
      entry: isEn ? "Entry" : "入市價",
      neutral: isEn ? "Neutral " : isCn ? "止损价" : "止損價",
      expect: isEn ? "Expect" : isCn ? "获利价" : "獲利價",
      ccy1: isEn ? "Currency 1" : isCn ? "货币 1" : "貨幣 1",
      ccy2: isEn ? "Currency 2" : isCn ? "货币 2" : "貨幣 2",
      cnview: isEn ? "View" : "看法",
      msg1_1: isEn ? "Message 1 - 1st Sentence" : "描述 1 - 第一句",
      msg1_2: isEn ? "Message 1 - 2nd Sentence" : "描述 1 - 第二句",
      msg2: isEn ? "Message 2" : "描述 2",
    };

    const keys = isYue
      ? {
          ccy1: "tw_ccy1",
          ccy2: "tw_ccy2",
          view: "tw_cnview",
          msg1_1: "amended_tw_msg1_1",
          msg1_2: "amended_tw_msg1_2",
          msg2: "amended_tw_msg2",
        }
      : isTc
        ? {
            ccy1: "tc_ccy1",
            ccy2: "tc_ccy2",
            view: "tc_cnview",
            msg1_1: "amended_tc_msg1_1",
            msg1_2: "amended_tc_msg1_2",
            msg2: "amended_tc_msg2",
          }
        : isCn
          ? {
              ccy1: "ccy1",
              ccy2: "ccy2",
              view: "cnview",
              msg1_1: "amended_msg1_1",
              msg1_2: "amended_msg1_2",
              msg2: "amended_msg2",
            }
          : {
              ccy1: "eng_ccy1",
              ccy2: "eng_ccy2",
              view: "eng_cnview",
              msg1_1: "amended_eng_msg1_1",
              msg1_2: "amended_eng_msg1_2",
              msg2: "amended_eng_msg2",
            };

    const maxLen = isEn ? maxENLength : maxCNLength;

    const val1_1 = watchAllFields[keys.msg1_1] || "";
    const val1_2 = watchAllFields[keys.msg1_2] || "";
    const val2 = watchAllFields[keys.msg2] || "";

    return (
      <>
        <div className="col-4 mt-4">
          <span>{labels.entry}</span>
          <input
            id="video-entry"
            disabled={disabled}
            placeholder={labels.entry}
            className="form-control mt-2"
            {...register("entry")}
            onChange={(e) => {
              register("entry").onChange(e);
              const updatedForm = { ...getValues(), entry: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>
        <div className="col-4 mt-4">
          <span>{labels.neutral}</span>
          <input
            id="video-neutral "
            disabled={disabled}
            placeholder={labels.neutral}
            className="form-control mt-2"
            {...register("neutral")}
            onChange={(e) => {
              register("neutral").onChange(e);
              const updatedForm = { ...getValues(), neutral: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>
        <div className="col-4 mt-4">
          <span>{labels.expect}</span>
          <input
            id="video-expect"
            disabled={disabled}
            placeholder={labels.expect}
            className="form-control mt-2"
            {...register("expect")}
            onChange={(e) => {
              register("expect").onChange(e);
              const updatedForm = { ...getValues(), expect: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>

        <div className="col-4">
          <input
            id={`video-${keys.ccy1}`}
            disabled={disabled}
            placeholder={labels.ccy1}
            className="form-control mt-4"
            {...register(keys.ccy1)}
            onChange={(e) => {
              register(keys.ccy1).onChange(e);
              const updatedForm = { ...getValues(), [keys.ccy1]: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>
        <div className="col-4">
          <input
            id={`video-${keys.ccy2}`}
            disabled={disabled}
            placeholder={labels.ccy2}
            className="form-control mt-4"
            {...register(keys.ccy2)}
            onChange={(e) => {
              register(keys.ccy2).onChange(e);
              const updatedForm = { ...getValues(), [keys.ccy2]: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>
        <div className="col-4">
          <input
            id={`video-${keys.view}`}
            disabled={disabled}
            placeholder={labels.cnview}
            className="form-control mt-4"
            {...register(keys.view)}
            onChange={(e) => {
              register(keys.view).onChange(e);
              const updatedForm = { ...getValues(), [keys.view]: e.target.value };
              updateVideoUrlAndPreview(
                input_date,
                input_view,
                lang,
                input_json?.views?.[input_view],
                updatedForm,
                audioVersion,
                sex,
              );
            }}
          />
        </div>

        <div className="col-12">
          <textarea
            id={`video-${keys.msg1_1}`}
            disabled={disabled}
            className="form-control mt-4 video-text-area"
            placeholder={labels.msg1_1}
            maxLength={maxLen}
            {...register(keys.msg1_1)}
          />
          <span>
            {isEn
              ? `${val1_1.length}/${maxLen} characters`
              : `共${val1_1.length}/${maxLen}字`}
          </span>
        </div>

        <div className="col-12">
          <textarea
            id={`video-${keys.msg1_2}`}
            disabled={disabled}
            className="form-control mt-4 video-text-area"
            placeholder={labels.msg1_2}
            maxLength={maxLen}
            {...register(keys.msg1_2)}
          />
          <span>
            {isEn
              ? `${val1_2.length}/${maxLen} characters`
              : `共${val1_2.length}/${maxLen}字`}
          </span>
        </div>

        <div className="col-12">
          <textarea
            id={`video-${keys.msg2}`}
            disabled={disabled}
            className="form-control mt-4 video-text-area"
            placeholder={labels.msg2}
            maxLength={maxLen}
            {...register(keys.msg2)}
          />
          <span>
            {isEn
              ? `${val2.length}/${maxLen} characters`
              : `共${val2.length}/${maxLen}字`}
          </span>
        </div>
      </>
    );
  };

  const DeleteModal = (props) => (
    <Modal {...props} centered>
      <Modal.Body>
        <div className="text-center">
          <i className="bi bi-exclamation-circle text-danger display-3"></i>
          <h5 className="mt-3">
            Are you sure to proceed and discard the changes
          </h5>
        </div>
        <div className="text-center mt-3 row">
          <div className="col-6">
            <button
              onClick={props.onHide}
              className="btn btn-success form-control mt-4"
              type="button"
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={DeleteModalConfirmHandle}
              className="btn btn-primary form-control mt-4"
              type="button"
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <DeleteModal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
      />

      <form onSubmit={handleSubmit(HandleUpdate)} className="video-section">
        <div className="row video-frame">
          <div className="col-12 pt-5 px-5 position-relative">
            <button
              onClick={LogoutButton}
              className="btn btn-warning btn-logout position-absolute"
              type="button"
            >
              Logout
            </button>
            <button
              onClick={ChangePasswordButton}
              className="btn btn-secondary btn-changepassword position-absolute"
              type="button"
            >
              Change Password
            </button>
            <img
              alt="scb_logo"
              className="banner m-auto"
              src="images/banner.svg"
            />
          </div>

          <div className="col-12 col-lg-6 p-5">
            {videoLoading ? (
              <div
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "16 / 9",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  backgroundColor: lang === "tc-CN" ? "#030a44" : "#0c55a9",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  gap: "16px",
                }}
              >
                <div
                  className="spinner-border text-light"
                  role="status"
                  style={{ width: "3.5rem", height: "3.5rem" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 500,
                    letterSpacing: "0.5px",
                  }}
                >
                  Loading video...
                </span>
              </div>
            ) : (
              <Player
                key={`${lang}-${input_date}-${input_view}-${audioVersion}-${videoProps?.ccy1 || ""}-${videoProps?.ccy2 || ""}-${videoProps?.cnview || ""}`}
                component={EnglishAdvertisement}
                inputProps={videoProps}
                durationInFrames={3980}
                compositionWidth={1920}
                compositionHeight={1080}
                fps={60}
                controls
                autoPlay
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "16 / 9",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              />
            )}
          </div>

          <div className="col-12 col-lg-6 p-5">
            <div className="row">
              <div className="col-12 col-lg-4">
                <select
                  className="form-select"
                  style={{ border: "1px solid #ced4da" }}
                  value={lang}
                  onChange={(e) => ConfirmModal("lang", e.target.value)}
                >
                  <option value="zn-CN">中文</option>
                  <option value="en">English</option>
                  <option value="yue-CN">中文-廣東話</option>
                  <option value="tc-CN">中文-繁體</option>
                </select>
              </div>

              <div className="col-12 col-lg-4">
                <select
                  className="form-select"
                  style={{ border: "1px solid #ced4da" }}
                  value={input_date}
                  onChange={(e) => ConfirmModal("date", e.target.value)}
                >
                  {input_datelist.map((data) => getDateItem(data))}
                </select>
              </div>

              {input_active && localStorage.getItem("permission") === "W" ? (
                <>
                  <div className="col-12 col-lg-4">
                    <select
                      className="form-select"
                      style={{ border: "1px solid #ced4da" }}
                      value={input_view}
                      onChange={(e) => ConfirmModal("view", e.target.value)}
                    >
                      {input_json?.views?.map((data, index) =>
                        lang === "zn-CN" ||
                        lang === "yue-CN" ||
                        lang === "tc-CN"
                          ? getViewsItem(
                              index,
                              data.ccy1,
                              data.ccy2,
                              data.cnview,
                            )
                          : getViewsItem(
                              index,
                              data.eng_ccy1,
                              data.eng_ccy2,
                              data.view,
                            ),
                      )}
                    </select>
                  </div>

                  {renderFieldGroup(false)}

                  <div className="col-12 mt-4">
                    <span>Voice</span>
                    <select
                      className="form-select mt-2"
                      style={{ border: "1px solid #ced4da" }}
                      value={sex}
                      onChange={(e) => handleSexChange(e.target.value)}
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>

                  {!isDirty ? (
                    <>
                      <div className="col-4">
                        <button
                          onClick={handleGetLink}
                          disabled={!videoLink}
                          title={
                            videoLink
                              ? "Copy video download link"
                              : "No link available yet"
                          }
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          Download
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          onClick={GenerateButton}
                          disabled={isGeneratingCurrent}
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          {generateBtnText}
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          disabled={!isDirty}
                          className="btn btn-primary form-control mt-4"
                          style={getBlueBtnStyle(!isDirty)}
                          type="submit"
                        >
                          Update
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-4">
                        <button
                          disabled
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          Download
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          onClick={() => HandleViewsSelector(input_view)}
                          className="btn btn-warning form-control mt-4"
                          type="button"
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          className="btn btn-primary form-control mt-4"
                          style={getBlueBtnStyle(false)}
                          type="submit"
                        >
                          Update
                        </button>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="col-12 col-lg-4">
                    <select
                      className="form-select"
                      style={{ border: "1px solid #ced4da" }}
                      value={input_view}
                      onChange={(e) => HandleViewsSelector(e.target.value)}
                    >
                      {input_json?.views?.map((data, index) =>
                        lang === "zn-CN" ||
                        lang === "yue-CN" ||
                        lang === "tc-CN"
                          ? getViewsItem(
                              index,
                              data.ccy1,
                              data.ccy2,
                              data.cnview,
                            )
                          : getViewsItem(
                              index,
                              data.eng_ccy1,
                              data.eng_ccy2,
                              data.view,
                            ),
                      )}
                    </select>
                  </div>

                  {renderFieldGroup(true)}

                  {input_active ? (
                    <>
                      <div className="col-12 mt-4">
                        <span>Voice</span>
                        <select
                          className="form-select mt-2"
                          style={{ border: "1px solid #ced4da" }}
                          value={sex}
                          onChange={(e) => handleSexChange(e.target.value)}
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                      <div className="col-4">
                        <button
                          onClick={handleGetLink}
                          disabled={!videoLink}
                          title={
                            videoLink
                              ? "Copy video download link"
                              : "No link available yet"
                          }
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          Download
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          onClick={GenerateButton}
                          disabled={isGeneratingCurrent}
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          {generateBtnText}
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          disabled={!isDirty}
                          className="btn btn-primary form-control mt-4"
                          style={getBlueBtnStyle(!isDirty)}
                          type="submit"
                        >
                          Update
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-4">
                        <button
                          disabled
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          Download
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          disabled
                          className="btn btn-success form-control mt-4"
                          type="button"
                        >
                          Generate
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          disabled
                          className="btn btn-primary form-control mt-4"
                          style={getBlueBtnStyle(true)}
                          type="submit"
                        >
                          Update
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Video;
